import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader
} from "@heroui/react";
import React from "react";

interface ConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    cardTitle: string;
    cardDescription: string;
    buttonText: string;
    onConfirm?: () => void | Promise<void>;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    isOpen,
    onClose,
    cardTitle,
    cardDescription,
    buttonText,
    onConfirm,
}) => {
    console.log("ConfirmModal rendered, isOpen:", isOpen);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalContent>
                <ModalHeader className="flex flex-col gap-1">
                    {cardTitle}
                </ModalHeader>
                <ModalBody>
                    <p className="text-gray-600">
                        {cardDescription}
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="flat" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="solid"
                        color="primary"
                        onClick={async () => {
                            if (onConfirm) {
                                const result = onConfirm();
                                if (result instanceof Promise) {
                                    await result;
                                }
                            }
                            onClose();
                        }}
                    >
                        {buttonText}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmModal;